import { createSelector } from 'reselect';
import { keys, pathOr, pipe, prop, props, head, propEq, filter, either, compose, find, values } from 'ramda';
import { FILTERS_HOMEPAGE, FILTERS_COMMON } from './filters.constants';
import { getFiltersQuery } from './filters.utils';

export const selectFiltersDomain = prop('filters');

export const selectFilterList = createSelector(
  selectFiltersDomain,
  prop('list')
);

export const selectCurrentFilterName = createSelector(
  selectFiltersDomain,
  prop('currentFilterName')
);

export const selectIsModalVisible = createSelector(
  selectFiltersDomain,
  prop('isModalVisible')
);

export const selectCurrentFilter = createSelector(
  selectCurrentFilterName,
  selectFilterList,
  prop
);

export const selectHomepageFilters = createSelector(
  selectFilterList,
  props(FILTERS_HOMEPAGE)
);

export const selectCommonFilters = createSelector(
  selectFilterList,
  props(FILTERS_COMMON)
);

export const selectFiltersQuery = createSelector(
  selectFilterList,
  getFiltersQuery
);

export const selectFirstSelectedMarketId = createSelector(
  selectFilterList,
  pipe(
    pathOr({}, ['location', 'data']),
    filter(
      either(
        propEq('value', true),
        compose(
          find(propEq('value', true)),
          values,
          prop('regions')
        )
      )
    ),
    keys,
    head
  )
);
